<template>
  <action-dispatcher
    action="product/getProduct"
    :parameters="$route.params.id"
    class="view-product-upsell"
  >
    <bp-header
      class="mb-7"
      title="Funil de vendas"
      subtitle="Monte uma sequência de passos para definir preços de maneira automatizada."
    />

    <div
      v-if="!funnels.length"
      class="container centralize-row text-center pt-9"
    >
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <img
            class="d-block mb-9 mx-auto"
            src="@/assets/images/home/welcome.svg"
          />
          <h5>Ainda não há nada aqui</h5>
          <div class="text-secondary mb-9">
            Não há ofertas de upsell cadastradas até o momento.
          </div>
          <router-link
            class="btn btn-primary"
            :to="{
              name: 'product-upsell-new',
              params: { id: $route.params.id }
            }"
          >
            Novo funil
          </router-link>
        </div>
      </div>
    </div>
    <div v-else class="pt-9">
      <div class="row mb-3">
        <div class="col-lg-5 mb-3">
          <div class="d-flex align-items-center">
            <h5 class="mr-6 mb-0">
              Funis adicionados
            </h5>
            <button
              class="btn btn-sm btn-outline-primary btn-square-sm p-5"
              @click="refresh"
            >
              <i class="icon-refresh-ccw" />
            </button>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="row">
            <div class="col-lg-8 mb-3 mb-lg-0">
              <!-- <search-filter
                class="flex-fill mr-3"
                placeholder="Pesquisar funil"
                @search="searching"
                :showResultsDropdown="false"
              /> -->
            </div>
            <div class="col-lg-4">
              <div class="d-flex justify-content-end">
                <router-link
                  class="btn btn-primary btn-block d-lg-none"
                  :to="{
                    name: 'product-upsell-new',
                    params: { id: product.id }
                  }"
                >
                  Novo funil
                </router-link>
                <router-link
                  class="btn btn-primary d-none d-lg-flex"
                  :to="{
                    name: 'product-upsell-new',
                    params: { id: product.id }
                  }"
                >
                  Novo funil
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" />
      </div>

      <div v-else>
        <data-table
          class="d-none d-lg-block pt-5"
          :columns="responsive.columns"
          :data="funnels"
          :firstColumnFr="1"
          :lastColumnFr="0.5"
        >
          <template #default="{ item }">
            <div class="d-flex align-items-center text-truncate">
              {{ item.name }}
            </div>
            <div class="d-flex align-items-center text-truncate">
              {{ item.product.name }}
            </div>
            <div
              class="d-flex align-items-center"
              :class="{
                'text-success': item.is_active,
                'text-danger': !item.is_active
              }"
            >
              <strong>{{ item.is_active | formatStatus }}</strong>
            </div>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @edit="editFunnel(item)"
                @steps="editSteps(item)"
                @change-status="changeStatus(item)"
                @remove="removeFunnel(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- mobile area -->
        <data-table
          class="d-lg-none"
          :columns="responsive.columns.slice(0, 2).map(() => '')"
          :data="funnels"
          :firstColumnFr="2"
          :lastColumnFr="0.5"
        >
          <template #default="{ item }">
            <div class="d-flex flex-column text-left pl-3 py-5">
              <small class="d-flex align-items-center text-truncate">
                <strong class="mr-3">Oferta:</strong>
                {{ item.name }}
              </small>
              <small class="d-flex align-items-center text-success">
                <strong class="mr-3 text-dark">Status:</strong>
                <strong
                  :class="{
                    'text-success': item.is_active,
                    'text-danger': !item.is_active
                  }"
                  >{{ item.is_active | formatStatus }}</strong
                >
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @edit="editFunnel(item)"
                @steps="editSteps(item)"
                @change-status="changeStatus(item)"
                @remove="removeFunnel(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- mobile area -->
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import ProductActionsMixin from "@/mixins/productActions.js";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin],
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("funnel", ["funnels"])
  },
  filters: {
    formatStatus(dt) {
      return dt ? "Ativo" : "Inativo";
    }
  },
  data() {
    return {
      params: {
        product_id: this.$route.params.id
      },
      loading: false,
      search: "",
      editedIndex: null,
      responsive: {
        columns: ["Nome do funil", "produto", "Status", ""]
      }
    };
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    getActions(item) {
      return [
        {
          text: item.is_active ? "Desativar" : "Ativar",
          class: item.is_active ? "text-danger" : "text-success",
          icon: "icon-power",
          confirmation: {
            enable: false
          },
          event: "change-status"
        },
        {
          text: "Editar etapas",
          class: "",
          icon: "icon-arrow-right",
          confirmation: {
            enable: false
          },
          event: "steps"
        },
        {
          text: "Editar Funil",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text: "Deseja mesmo excluir este funil?"
          },
          event: "remove"
        }
      ];
    },
    changeStatus(item) {
      this.$store
        .dispatch("funnel/put", {
          id: item.id,
          is_active: !item.is_active
        })
        .then(() => {
          this.dispatch();
        });
    },
    editSteps(funnel) {
      this.$router.push({
        name: "product-upsell-tree",
        params: { tree: funnel.tree_id }
      });
    },
    editFunnel(funnel) {
      this.$router.push({
        name: "product-upsell-edit",
        params: { funnel: funnel.id }
      });
    },
    removeFunnel(funnel) {
      this.$store.dispatch("funnel/delete", funnel.id).then(this.refresh);
    },
    searching(v) {
      this.search = v;
    },
    refresh() {
      this.dispatch();
    },
    dispatch() {
      this.loading = true;
      this.$store.dispatch("funnel/get", this.params).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.view-product-upsell {
  a {
    text-decoration: none;
  }
  .box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #d2d0d8;
    border-radius: 4px;
    height: 232px;
    cursor: pointer;
    img {
      height: 54px;
      width: 54px;
    }

    &:hover {
      background: linear-gradient(148.5deg, #ee6469 -19.31%, #5576ec 100%);
      border-color: rgb(191, 92, 170);

      strong {
        color: white;
      }
    }
  }
}
</style>
